import React, {useEffect, useState} from "react";
import MatSwitch from "../../../components/common/Mat/MatSwitch";
import MatSidebarToolbox from "../../../components/common/Mat/MatSidebarToolbox";
import { connect } from "react-redux";
import { Glyphicon } from "react-bootstrap";
import { ButtonIcon, UserNameContainer } from "../../../components/navbarStyles";
import {setDashboardCustomizerUpdate, setOrderCustomization} from "./actions/detailsPageActions";
import {PERMISSION_CLIENT_PANEL, PERMISSION_EDIT_USERS} from "../../../../../common/src/permissions";

const ViewCustomizerSidebar = ({ setDashboardCustomizerUpdateData, customizer, onToggleChange, dispatch, clientPanelPermission, editUserPanelPermission, hasActiveUser }) => {
    const [lastParam, setLastParam] = useState('');
    const [customerId, setCustomerId] = useState('');

    useEffect(() => {
        const pathname = window.location.pathname;
        const segments = pathname.split('/').filter(segment => segment !== '');
        const last = segments[segments.length - 1] || '';
        setLastParam(last);
        const customerId = segments[segments.length - 4] || "";
        setCustomerId(customerId);
    }, []);

    // Filtruj tylko elementy które mają show: 1
    const visibleElements = customizer.filter(element => (element.show === 1));

    // Handler dla zmiany stanu przełącznika (enabled/disabled)
    const handleSwitchChange = (key, checked) => {
        // Aktualizuj customizer w Redux - zmień enabled dla konkretnego elementu
        const updatedCustomizer = customizer.map(element =>
            element.key === key
                ? { ...element, enabled: checked }
                : element
        );

        setDashboardCustomizerUpdateData(updatedCustomizer, lastParam, customerId);

        // Opcjonalnie: wywołaj callback jeśli jest przekazany przez props
        if (onToggleChange) {
            const enabledKeys = updatedCustomizer.filter(el => el.enabled).map(el => el.key);
            onToggleChange(key, checked, enabledKeys);
        }

        console.log(`Toggled ${key}: ${checked}`);
    };

    // Handler dla zmiany stanu checkbox'a (disabled)
    const handleDisableChange = (key, isDisabled) => {
        // Aktualizuj customizer w Redux - zmień disabled dla konkretnego elementu
        // Jeśli element staje się disabled, automatycznie ustaw enabled na false
        let updatedCustomizer = customizer.map(element =>
            element.key === key
                ? {
                    ...element,
                    disabled: isDisabled,
                    enabled: isDisabled ? false : element.enabled  // Wyłącz gdy disabled = true
                }
                : element
        );
        if(key == 4) {
            // if working hours table is hidden for customer we should also hide working hours chart
            updatedCustomizer =  updatedCustomizer.map(element =>
                element.key == 18
                    ? {
                        ...element,
                        disabled: isDisabled,
                        enabled: isDisabled ? false : element.enabled  // Wyłącz gdy disabled = true
                    }
                    : element
            );
        }
        setDashboardCustomizerUpdateData(updatedCustomizer, lastParam, customerId);

        // Wywołaj callback dla zmiany enabled jeśli element został wyłączony
        if (isDisabled && onToggleChange) {
            const enabledKeys = updatedCustomizer.filter(el => el.enabled).map(el => el.key);
            onToggleChange(key, false, enabledKeys);
        }

        console.log(`Toggled disabled ${key}: ${isDisabled}, enabled automatically set to: ${isDisabled ? false : 'unchanged'}`);
    };

    // Metoda do resetowania wszystkich przełączników
    const handleResetAll = () => {
        // Ustaw wszystkie enabled na false
        const updatedCustomizer = customizer.map(element => ({
            ...element,
            enabled: false
        }));

        setDashboardCustomizerUpdateData(updatedCustomizer, lastParam, customerId);

        if (onToggleChange) {
            onToggleChange('reset', false, []);
        }
    };

    // Metoda do włączenia wszystkich przełączników
    const handleEnableAll = () => {
        // Ustaw wszystkie widoczne elementy na enabled: true (ale tylko te które nie są disabled)
        const updatedCustomizer = customizer.map(element => ({
            ...element,
            enabled: (element.show === 1 && !element.disabled) ? true : element.enabled
        }));

        setDashboardCustomizerUpdateData(updatedCustomizer, lastParam, customerId);

        if (onToggleChange) {
            const enabledKeys = updatedCustomizer.filter(el => el.enabled).map(el => el.key);
            onToggleChange('enableAll', true, enabledKeys);
        }
    };

    // Oblicz liczbę włączonych elementów z Redux state
    const enabledCount = customizer.filter(element => element.enabled).length;
    const disabledCount = customizer.filter(element => element.disabled).length;

    return (
        <MatSidebarToolbox>
            <div>CUSTOMIZER</div>
            <div>
                <sub>Customize and preview in real time.</sub>
            </div>
            <hr/>

            {/* Kontrolki do zarządzania wszystkimi przełącznikami */}
            <div style={{ marginBottom: '10px', display: 'flex', gap: '5px' }}>
                <button
                    onClick={handleEnableAll}
                    style={{
                        fontSize: '11px',
                        padding: '2px 6px',
                        background: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: 'pointer'
                    }}
                >
                    Enable All
                </button>
                <button
                    onClick={handleResetAll}
                    style={{
                        fontSize: '11px',
                        padding: '2px 6px',
                        background: '#f44336',
                        color: 'white',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: 'pointer'
                    }}
                >
                    Reset All
                </button>
            </div>

            <div>
                {visibleElements.map(col => {
                    return  (
                    <div key={col.key} style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '8px',
                        padding: '4px 0',
                        borderBottom: '1px solid #f0f0f0'
                    }}>
                        {/* Ikona kłódki zamiast checkbox'a */}
                        {!clientPanelPermission && editUserPanelPermission&& (lastParam === customerId) && (<div style={{
                            marginRight: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            padding: '2px'
                        }}
                             // onClick={hasActiveUser ? ()=>{} : () => handleDisableChange(col.key, !col.disabled)}//feature blocked after accepted regulations by customers accounts
                             onClick={() => handleDisableChange(col.key, !col.disabled)}
                             title={col.disabled ? 'Click to unlock (enable switch)' : 'Click to lock (disable switch)'}
                        >
                            <Glyphicon
                                glyph={col.disabled ? "eye-close" : "eye-open"}
                                style={{
                                    fontSize: '14px',
                                    // color: hasActiveUser ? 'black' : (col.disabled ? '#f44336' : '#4CAF50'),//feature blocked after accepted regulations by customers accounts
                                    color: col.disabled ? '#f44336' : '#4CAF50',
                                    transition: 'color 0.2s ease'
                                }}
                            />
                        </div>)}

                        {/* Główny przełącznik */}
                        <div style={{
                            flex: 1,
                            opacity: col.disabled ? 0.5 : 1,
                            transition: 'opacity 0.2s ease'
                        }}>
                            <MatSwitch
                                label={col.title}
                                fullWidth
                                checked={!!col.enabled}
                                // disabled={!!col.disabled} //feature blocked after accepted regulations by customers accounts
                                onChange={ev => {
                                    if (!col.disabled) {
                                        handleSwitchChange(col.key, ev.target.checked);
                                    }
                                }}
                                style={{
                                    pointerEvents: col.disabled ? 'none' : 'auto'
                                }}
                            />
                        </div>
                    </div>
                )
                })}
            </div>

            {/* Informacja o aktualnie włączonych elementach */}
            <div style={{ marginTop: '10px', fontSize: '11px', color: '#666' }}>
                <div>Active: {enabledCount} / {visibleElements.length}</div>
                {!clientPanelPermission && (<div>Disabled: {disabledCount} / {visibleElements.length}</div>)}
                <div>Available: {visibleElements.filter(el => !el.disabled).length} / {visibleElements.length}</div>
                {customizer.length !== visibleElements.length && !clientPanelPermission && (
                    <div style={{ color: '#999' }}>
                        Hidden: {customizer.length - visibleElements.length}
                    </div>
                )}
            </div>
        </MatSidebarToolbox>
    );
};

// Connect do Redux
export default connect(state => ({
    customizer: state.clientPanel.detailsPageReducer.customizations || [],
    hasActiveUser: state.clientPanel.detailsPageReducer.hasActiveUser,
    clientPanelPermission: state.auth.user && state.auth.user.group.permissions.indexOf(PERMISSION_CLIENT_PANEL) !== -1,
    editUserPanelPermission: state.auth.user && state.auth.user.group.permissions.indexOf(PERMISSION_EDIT_USERS) !== -1
}), (dispatch) => ({
    setDashboardCustomizerUpdateData: (data, lastParam, customerId) => {
        dispatch(setDashboardCustomizerUpdate(data))
        dispatch(setOrderCustomization(lastParam, customerId))
    }
}))(ViewCustomizerSidebar);